import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteSchedulesFromAddGroup = api(async function deleteSchedulesFromAddGroup({
    projectId,
    groupId,
    scheduleIds,
}) {
    return mutate(
        gql`
            mutation DeleteSchedulesFromAddGroup($projectId: String!, $groupId: String!, $scheduleIds: [String!]!) {
                deleteSchedulesFromAddGroup(projectId: $projectId, groupId: $groupId, scheduleIds: $scheduleIds)
            }
        `,
        { projectId, groupId, scheduleIds },
        { returns: "deleteSchedulesFromAddGroup" }
    )
})
